import { render, staticRenderFns } from "./ShopDetail.vue?vue&type=template&id=08d9aa47"
import script from "./ShopDetail.vue?vue&type=script&lang=js"
export * from "./ShopDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports